export default {"src":"/_next/static/image/public/images/ic_insurance_white_vertical_menu.ec4b14b3381fdd1b5c207436543b4dbe.svg","height":20,"width":20};